import { Footer } from "@components/site/Footer"
import { Header } from "@components/site/Header"
import { cartStore } from "@features/auth/tess-cart.store"
import { authStore } from "@features/auth/tess-session.store"
import { FlyingCarpet } from "@features/flying-carpet/FlyingCarpet"
import { useDebugNode } from "eddev/blocks"
import { ScrollRestoration } from "eddev/routing"
import { defineView } from "eddev/views"
import { observer } from "mobx-react-lite"
import { onAction, onPatch } from "mobx-state-tree"
import { useEffect } from "react"
import "../server/_client-config"

export default defineView("_app", (props) => {
  return (
    <>
      <ScrollRestoration />
      <Header />
      <FlyingCarpet />
      {props.children}
      <Footer />
      <Debugger />
    </>
  )
})

const Debugger = observer(() => {
  const accountDebugger = useDebugNode("Account", {
    ...authStore,
  })
  const cartDebugger = useDebugNode("Cart", {
    ...cartStore,
  })

  useEffect(() => {
    onAction(authStore, (action) => {
      accountDebugger.log(action.name + (action.path ? ":" + action.path : ""), action.args)
    })
    onPatch(authStore, (patch) => {
      Object.assign(accountDebugger, authStore)
    })
    onAction(cartStore, (action) => {
      cartDebugger.log(action.name + (action.path ? ":" + action.path : ""), action.args)
    })
    onPatch(cartStore, () => {
      Object.assign(cartDebugger, cartStore)
    })
  }, [])

  return null
})
